import { render, staticRenderFns } from "./Sidenav.vue?vue&type=template&id=715a8a4a"
import script from "./Sidenav.vue?vue&type=script&lang=js"
export * from "./Sidenav.vue?vue&type=script&lang=js"
import style0 from "./Sidenav.vue?vue&type=style&index=0&id=715a8a4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports